import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-mappings-modal',
  templateUrl: './nr-not-mapped-modal.component.html',
  styleUrls: ['./nr-not-mapped-modal.component.scss'],
})
export class NrNotMappedModalComponent{

  constructor(
    public dialogRef: MatDialogRef<NrNotMappedModalComponent>
  ) { }

  closeModal() {
    this.dialogRef.close("close");
  }
}
